import styled, { css } from "styled-components";

export type Type = 'primary' | 'secondary' | 'external' | 'internal' | 'download' | 'link' | 'arrow';

interface ButtonProps {
    type: Type;
    isDisabled: boolean;
    isDynamicBtn?: boolean;
}

export const StyledButton = styled.a<ButtonProps>`
    display: inline-flex;
    justify-content: center;
    align-items: center;
    min-width: 134px;
    height: 42px;
    padding: 8px;
    font-size: 16px;
    color: ${({ theme }) => theme.palette.secondary.text};
    background-color: ${({ theme })  => theme.palette.secondary.normal};
    text-decoration: none;
    border: solid 1px #000;
    border-radius: 21px;
    cursor: pointer;

    &:hover {
        color: #000;
        background-color: ${({ theme })  => theme.palette.secondary.hover};
    }

    ${({ type, theme}) => type === 'primary' && css`
        border: none;
        color: ${theme.palette.primary.text};
        background-color: ${theme.palette.primary.normal};
        &:hover {
            color: #FFF;
            background-color: ${theme.palette.primary.hover};
        }
    `}

    ${({ type, theme }) => (type === 'internal' || type === 'external') && css`
        text-decoration: underline;
        border: none;
        color: ${theme.palette.primary.normal};
        background-color: transparent;
        &:hover {
            color: ${theme.palette.primary.normal};
            background-color: transparent;
        }
        &:visited {
            color: ${theme.palette.primary.hover};
        }
    `}

    ${({ type, theme }) => (type === 'arrow' || type === 'download' || type === 'link') && css`
        text-decoration: underline;
        padding: 0;
        border: none;
        color: ${theme.palette.primary.normal};
        background-color: transparent;
        &:hover {
            color: ${theme.palette.hover.color};
            background-color: transparent;
            transition: linear 0.2s;
        }
        &&& {
            @media screen and (min-width: ${theme.breakpoints.sm}){
                min-width: 0;
            } 
        }
    `}
   
    ${({ isDisabled }) => isDisabled && css`
        opacity: .5;
        cursor: not-allowed;
        pointer-events: none;
    `}

    ${({isDynamicBtn, type, theme })=> isDynamicBtn && css`
        ${(type === 'internal' || type === 'external') && `
        justify-content: left;
        padding-left: unset;
        width: fit-content;
        block-size: fit-content;
        &:hover {
          background-color: transparent;
        }`}
        
        @media screen and (max-width: ${theme.breakpoints.sm}){
            width: 100%;
        } 
    `}

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.sm}){
        min-width: 170px;
        height: 56px;
        font-size: 18px;
        border-radius: 28px;
    }
`;